import { render, staticRenderFns } from "./pcTabBarComponent.vue?vue&type=template&id=54456b84&scoped=true"
import script from "./pcTabBarComponent.vue?vue&type=script&lang=js"
export * from "./pcTabBarComponent.vue?vue&type=script&lang=js"
import style0 from "./pcTabBarComponent.vue?vue&type=style&index=0&id=54456b84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54456b84",
  null
  
)

export default component.exports